<template>
  <div class="cooperation-report-detail-list-container">
    <template v-if="item.approvestate == '已审核'">
      <div>
        <div class="text-content">
          <span
            >申报日期 ：{{
              item.applydate && moment(item.applydate).format('YYYY-MM-DD')
            }}</span
          >
          <span
            >审定日期 ：{{
              item.approvedate && moment(item.approvedate).format('YYYY-MM-DD')
            }}</span
          >
        </div>
        <span
          :class="
            item && item.approvestate == '已审核'
              ? 'text-icon-gray'
              : 'text-icon-gold'
          "
          >{{ item && item.approvestate }}</span
        >
      </div>
      <div class="point-text">
        <p>本期申报金额：{{ item && item.applyamount | money2 }}</p>
        <p>审定金额：{{ item && item.approveamount | money2 }}</p>
        <p>实际应付进度款：{{ item && item.scheduleamount | money2 }}</p>
      </div>
      <p class="last-text">
        <span>形象进度情况：</span>
        <span>{{ item && item.imageprogress }}</span>
      </p>
    </template>
    <template v-else>
      <div>
        <div class="text-content">
          <span
            >申报日期 ：{{
              item.applydate && moment(item.applydate).format('YYYY-MM-DD')
            }}</span
          >
          <span
            >审定日期 ：{{
              item.approvedate && moment(item.approvedate).format('YYYY-MM-DD')
            }}</span
          >
        </div>
        <span
          :class="
            item && item.approvestate == '已审核'
              ? 'text-icon-gray'
              : 'text-icon-gold'
          "
          >{{ item && item.approvestate }}</span
        >
      </div>
      <div class="point-text">
        <p>申报金额：{{ item && item.applyamount | money2 }}</p>
      </div>
      <!-- <p class="last-text">形象进度情况：{{item && item.imageprogress}}</p> -->
      <p class="last-text">
        <span>形象进度情况：</span>
        <span>{{ item && item.imageprogress }}</span>
      </p>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'cooperation-report-detail-list',
  props: {
    isAudit: {
      type: Boolean,
      default: () => true
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      moment
    };
  },
  mounted() {},

  components: {},

  methods: {}
};
</script>

<style scoped lang="scss">
.cooperation-report-detail-list-container {
  color: #666666;
  font-size: 26px;
  padding: 20px;
  padding-right: 0px;
  border-bottom: 1px solid #f2f2f2;
  position: relative;
  z-index: 9;
  .text-content {
    // width: 85%;
    display: inline-block;
    span:nth-child(2) {
      margin-left: 20px;
    }
  }
  .last-text {
    margin-top: 10px;
    color: #666;
    display: flex;
    span:nth-child(1) {
      line-height: 1.5;
      width: 186px;
      display: inline-block;
      color: #999;
    }
    span:nth-child(2) {
      line-height: 1.5;
      flex: 1;
      color: #666;
    }
  }
  .point-text {
    font-size: 28px;
    font-weight: 500;
    color: #000000;
    p {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
  .text-icon-gold {
    width: 105px;
    height: 40px;
    display: inline-block;
    background: url('../../../common/images/visa-change/gold-icon.png')
      no-repeat center;
    background-size: 100% 100%;
    text-align: center;
    padding-left: 10px;
    color: white;
    line-height: 40px;
    font-size: 22px;
    position: absolute;
    right: 0px;
  }
  .text-icon-gray {
    width: 105px;
    height: 40px;
    display: inline-block;
    background: url('../../../common/images/visa-change/gray-icon.png')
      no-repeat center;
    background-size: 100% 100%;
    text-align: center;
    padding-left: 10px;
    color: white;
    line-height: 40px;
    font-size: 22px;
    position: absolute;
    right: 0px;
  }
}
</style>
<style lang="scss">
.cooperation-report-detail-list-container {
}
</style>
